/**
 * DevExtreme (esm/ui/data_grid/ui.data_grid.editing_form_based.js)
 * Version: 22.1.4
 * Build date: Fri Jul 22 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import gridCore from "./ui.data_grid.core";
import {
    editingFormBasedModule
} from "../grid_core/ui.grid_core.editing_form_based";
gridCore.registerModule("editingFormBased", editingFormBasedModule);
